import { connect } from 'react-redux';
import PhoneNumberForm from '../../../components/login/mfa/PhoneNumberForm';

export default connect(_ => ({}), {})(PhoneNumberForm);
